// PcPortable.jsx — toggle par carte, addition des suppléments, format € + HT/TTC + Prix sur demande
import React, { useEffect, useState } from "react";
import ProductCard from "../../../Hook/Pc";
import CpuIcon from "../../../Hook/icone/cpu.png";
import GpuIcon from "../../../Hook/icone/gpu.png";
import RamIcon from "../../../Hook/icone/ram.png";
import SsdIcon from "../../../Hook/icone/ssd.png";
import { useNavigate } from "react-router-dom";
import "../Ordinateur.css";

const PcPortable = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [proOn, setProOn] = useState(new Set()); // ids en mode Option Pro

  useEffect(() => {
    fetch("https://www.amservices.eu/api/products-pcportable.php")
      .then(res => res.json())
      .then(data => setProducts(Array.isArray(data) ? data : []))
      .catch(console.error);
  }, []);

  // Parsing numérique pour les calculs de prix
  const num = v => {
    if (v == null) return 0;
    const s = String(v).trim().replace(/\s|€|HT|TTC/gi, "").replace(",", ".");
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
  };

  // Calcul du taux de TVA basé sur les prix fournis
  const vatRate = (ht, ttc) => (ht > 0 && ttc > 0 ? Math.max(0, Math.min(1, ttc / ht - 1)) : 0.2);

  // Formatage monétaire
  const fmt = n => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n);
  const label = (n, kind) => `${fmt(n)} ${kind}`;

  const togglePro = (id) =>
    setProOn(s => { 
      const n = new Set(s); 
      n.has(id) ? n.delete(id) : n.add(id); 
      return n; 
    });

  return (
    <>
      <h1 className="sr-only">PC portables professionnels : conseil, vente et mise en service</h1>
      <h2 className="section-title">Nos PC Portables</h2>

      <div className="product-list">
        {products.map(product => {
          const showPro = proOn.has(product.id);
          
          // Vérification si le produit est en "Prix sur demande"
          const isRequest = product.price_on_request === true || product.price_on_request === "1";

          // Logique de prix de base
          const baseHT = num(product.price_ht);
          const baseTTC = num(product.price_ttc);
          const tva = vatRate(baseHT, baseTTC);

          // Suppléments Option Pro
          const supHT = num(product.price_ht_pro);
          const supTTC = product.price_ttc_pro ? num(product.price_ttc_pro) : supHT * (1 + tva);

          // Calculs finaux (utilisés si pas en mode "Prix sur demande")
          const priceHT = showPro ? baseHT + supHT : baseHT;
          const priceTTC = showPro ? baseTTC + supTTC : baseTTC;

          const hasPro = supHT > 0 || supTTC > 0;
          const optionText = hasPro ? (showPro ? "Option Pro appliquée" : "Option Pro disponible") : "";

          // Affichage des textes de prix
          const priceHTDisp = label(priceHT, "HT");
          const priceTTCDisp = label(priceTTC, "TTC");

          // Gestion des spécifications (changement dynamique selon Option Pro)
          const cpu = product.specs?.[0] || "";
          const gpu = product.specs?.[2] || "";
          const ram = showPro && product.option_ram ? product.option_ram : (product.specs?.[1] || "");
          const ssd = showPro && product.option_ssd ? product.option_ssd : (product.specs?.[3] || "");

          const specs = [
            { icon: CpuIcon, label: cpu },
            { icon: RamIcon, label: ram },
            { icon: GpuIcon, label: gpu },
            { icon: SsdIcon, label: ssd },
          ];

          return (
            <div key={product.id} className="product-with-toggle">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                {hasPro && (
                  <div
                    onClick={() => togglePro(product.id)}
                    title="Basculer ce produit en Option Pro"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      cursor: "pointer",
                      userSelect: "none",
                    }}
                  >
                    <div
                      style={{
                        width: 50,
                        height: 24,
                        borderRadius: 12,
                        background: showPro ? "#4caf50" : "#ccc",
                        position: "relative",
                        transition: "background 0.3s",
                        marginRight: 8,
                      }}
                    >
                      <div
                        style={{
                          width: 20,
                          height: 20,
                          borderRadius: "50%",
                          background: "#fff",
                          position: "absolute",
                          top: 2,
                          left: showPro ? 26 : 2,
                          transition: "left 0.3s",
                        }}
                      />
                    </div>
                    <span>{showPro ? "Option Pro" : "Option Initiale"}</span>
                  </div>
                )}
              </div>

              <ProductCard
                img={`https://www.amservices.eu/api/${product.logo}`}
                alt={product.title}
                title={product.title}
                specs={specs}
                priceHT={isRequest ? null : priceHTDisp}
                priceTTC={isRequest ? null : priceTTCDisp}
                priceOnRequest={isRequest} // Transmet l'état au composant enfant
                optionText={optionText}
              />
            </div>
          );
        })}
      </div>

      <div className='div_btn-retour'>
        <div className="btn-telephones" onClick={() => navigate("/ordinateur")}>
          Retour
        </div>
      </div>
    </>
  );
};

export default PcPortable;